import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel, Button, TextField } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import toast from "react-hot-toast";
import { useHistory, Link, useLocation } from "react-router-dom";
import {
  searchFilter,
  handleSort,
  portfolioReviewTabsPath,
} from "../../utils/varialbles";
import http from "../../services/reportsPath";
import SearchBar from "material-ui-search-bar";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  tableRow: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});

const DetailviewportfolioReview = ({}) => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [searched, setSearched] = useState("");
  const [orignalRows, setOriginalRows] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [editModal, setEditModal] = useState(false);
  const [dialogBoxfields, setdialogBoxfields] = useState({
    action: "",
    quantity: "",
    adviseID: "",
  });
  const [editedRow, seteditedRow] = useState([]);

  let history = useHistory();
  let location = useLocation();

  // console.log(location);

  //Update values based on keys for the column Recommended Action
  const recommendationActionmap = {
    H: "Hold",
    P: "Partial Sell",
    S: "Sell",
  };

  //Table Columns
  const [columns, setColumns] = useState([
    {
      headerName: "Stockname",
      id: "Company Name",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Asset Type",
      id: "Asset Class",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "ISIN",
      id: "ISIN",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Quantity",
      id: "Quantity",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Average Share Price",
      id: "Average Share Price",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Current Market Price",
      id: "Current Market Price",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Invested Amount",
      id: "Invested Amount",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Current Value",
      id: "Current Value",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Recommended Action",
      id: "Recommendation",
      show: true,
      minWidth: 100,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Recommended Action Quantity",
      id: "Recommendation Action Quantity",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    {
      headerName: "Amount",
      id: "Recommended Action Value",
      show: true,
      minWidth: 150,
      // headerAlign: "center",
      // align: "center",
    },
    { id: "edit", headerName: "", show: true },
  ]);

  const requestSearch = (searchedVal) => {
    let rowsTemp = [...rows];
    setPage(0);
    setOriginalRows(searchFilter(searchedVal, rowsTemp));
  };
  const cancelSearch = () => {
    // getData();
    setSearched("");
    requestSearch(searched);
  };

  useEffect(() => {
    getData();

    localStorage.setItem("adviserowsperpage", rowsPerPage);
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter");
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("selectedinvestorfiltersdata");
  }, []);

  const getData = (newQuery) => {
    let cust_id = location.state.cust_id;

    toast.loading("Please wait...");
    setOriginalRows([]);
    setRows([]);
    http
      .get("/portfolio_review_detail_view?req_status=R&cust_id=" + cust_id)
      .then((response) => {
        toast.dismiss();
        if (
          response &&
          response.data &&
          response.data.statusCode === 0 &&
          Array.isArray(response.data.Data)
        ) {
          let tempDta = response.data.Data;

          setOriginalRows(tempDta.slice().reverse());
          setRows(tempDta);
          setTotalRowCount(response.data.Data.totalRowCount);
        } else {
          setOriginalRows([]);
          setRows([]);
          setTotalRowCount(0);
        }
      });
  };

  let filteredCol = columns.filter((data) => {
    if (data.show) {
      return data;
    }
  });

  const handleChangePage = (event, newPage) => {
    // (newPage);
    setPage(newPage);
  };

  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);
    setRows(finalRows);
    setPage(0);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Edit Recommended Action and Quantity
  const editRow = (object) => {
    // console.log(object, "obj");

    // Add Quantity and Action to the Dialog fields
    // Replace null values with 0
    const newQuantity =
      object["Recommendation Action Quantity"] === null
        ? 0
        : object["Recommendation Action Quantity"];
    const actionRecommend =
      object["Recommendation"] === null ? "" : object["Recommendation"];

    const advise_id = object.advise_id;

    // Update the dialogBoxfields state with the new values
    setdialogBoxfields({
      quantity: newQuantity,
      action: actionRecommend,
      adviseID: advise_id,
    });
    // console.log(dialogBoxfields, "dialogBoxfields");

    setEditModal(true);
  };

  const gotoPendingPortfolioReview = (e) => {
    // history.goBack();
    // setTab(2);
    history.push({
      pathname: portfolioReviewTabsPath,
      state: {
        navigateTopage: 2,
      },
    });
  };

  //Quantity
  const handleEditDialogBoxFields = (event, fieldName) => {
    // const newValue = parseFloat(event.target.value);
    const newValue = event.target.value;
    // console.log(newValue, "quantity");
    setdialogBoxfields((prevState) => ({
      ...prevState,
      [fieldName]: newValue,
    }));
  };

  // Update action or quantity fields
  const updateFields = () => {
    // console.log(dialogBoxfields, "dialogBoxfields");

    if (
      dialogBoxfields &&
      dialogBoxfields.adviseID &&
      dialogBoxfields.action === "P"
    ) {
      http
        .get(
          "edit_review_advise" +
            "?advise_id=" +
            dialogBoxfields.adviseID +
            "&" +
            "savartopinion=" +
            dialogBoxfields.action +
            "&" +
            "recommended_action_quantity=" +
            dialogBoxfields.quantity
        )
        .then((res) => {
          if (res.data.statusCode === 0) {
            toast.success("Recommended Action Quantity Updated");
            setEditModal(false);
            // setadviseID(res.data.Data);
            // console.log(res.data.Data, "adviseID");
            reqTableRow(res.data.Data);

            // update to initial state
            setdialogBoxfields({
              quantity: "",
              action: "",
              adviseID: "",
            });
          } else if (res.data.statusCode === 1) {
            toast.error("An error occured");
          }
        })
        .catch((error) => {
          console.log("Error found");
        });
    } else if (dialogBoxfields.adviseID) {
      http
        .get(
          "edit_review_advise" +
            "?advise_id=" +
            dialogBoxfields.adviseID +
            "&" +
            "savartopinion=" +
            dialogBoxfields.action
        )
        .then((res) => {
          if (res.data.statusCode === 0) {
            toast.success("Updated Successfully");
            setEditModal(false);

            reqTableRow(res.data.Data);

            // update to initial state
            setdialogBoxfields({
              quantity: "",
              action: "",
              adviseID: "",
            });
          } else if (res.data.statusCode === 1) {
            toast.error("An error occured");
          }
        })
        .catch((error) => {
          console.log("Error found");
        });
    }
  };

  const sendToClient = () => {
    // console.log(orignalRows, "orignalRows");
    const lastRequestId = orignalRows[orignalRows.length - 1]?.request_id;

    // console.log(lastRequestId, "lastRequestId");
    http
      .get(`/submit_to_research_team?new_status=A&req_id=` + lastRequestId)
      .then((res) => {
        if (res.data.statusCode === 0) {
          toast.success("Sent to Client");
          gotoPendingPortfolioReview();
        } else if (res.data.statusCode === 1) {
          toast.error(res.data.error);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const reqTableRow = (adviseID) => {
    if (adviseID) {
      http
        .get(`/fetch_advise?advise_id=${adviseID}`)
        .then((res) => {
          updateTableRows(res.data.Data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const updateTableRows = (row) => {
    const rowIndexToUpdate = orignalRows.findIndex(
      (item) => item.request_id === row[0].request_id
    );

    // If the index is found, replace the object with the updated object from array2
    if (rowIndexToUpdate !== -1) {
      const updatedRows = [...orignalRows];
      updatedRows[rowIndexToUpdate] = row[0];
      setOriginalRows(updatedRows);
    }
  };

  return (
    <>
      <Grid container alignItems="center">
        <Grid item xs>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoPendingPortfolioReview}
          >
            Back
          </Button>
        </Grid>

        <Grid item xs style={{ textAlign: "center" }}>
          <h1>{location.state.Name} Portfolio Review</h1>
        </Grid>
        <Grid item xs style={{ textAlign: "right" }}>
          <Button
            variant="contained"
            color="primary"
            // endIcon={<ArrowFrontIosIcon />}
            onClick={sendToClient}
            // sx={{ backgroundColor: "center" }}
          >
            Approve and Send
          </Button>
        </Grid>
      </Grid>

      <Paper className={classes.root}>
        <div className="prospectsearchfilterboth">
          <div className="prospectsearch">
            <SearchBar
              value={searched}
              onChange={(searchVal) => requestSearch(searchVal)}
              onCancelSearch={() => cancelSearch()}
            />
          </div>

          <div>
            <TablePagination
              rowsPerPageOptions={[10, 50, 100, 1500]}
              component="div"
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>
        </div>

        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {filteredCol.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="prospect_table"
                  >
                    {/* <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    > */}
                    {column.headerName}
                    {/* </TableSortLabel> */}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {orignalRows.length !== 0 ? (
                <>
                  {orignalRows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index + "a"}
                          className="prospecttable"
                        >
                          {filteredCol.map((column, index) => {
                            const value = row[column.id];

                            return (
                              <TableCell
                                key={index + column.id}
                                align={column.align}
                                // onDoubleClick={() => viewProspectDetails(row)}
                              >
                                {column.id === "edit" ? (
                                  <Button
                                    style={{
                                      borderRadius: 10,
                                      marginLeft: 10,
                                      textTransform: "math-auto",
                                    }}
                                    onClick={() => editRow(row, "edit")}
                                    variant="contained"
                                    color="primary"
                                  >
                                    Edit
                                  </Button>
                                ) : recommendationActionmap[value] ? (
                                  recommendationActionmap[value]
                                ) : value === null ? (
                                  "N/A"
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </>
              ) : (
                <TableCell
                  colspan="6"
                  style={{ "text-align": "center", margin: "10px 0px" }}
                >
                  No Records to Show
                </TableCell>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <div>
          <TablePagination
            rowsPerPageOptions={[10, 50, 100, 1500]}
            component="div"
            count={orignalRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </Paper>

      {/* Edit Dialog */}
      <Dialog
        open={editModal}
        onClose={() => setEditModal(false)}
        //   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Do you want to edit the below fields?
        </DialogTitle>
        <DialogContent>
          <TextField
            style={{ marginRight: 10, width: 200 }}
            variant="outlined"
            select
            size="small"
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            value={dialogBoxfields.action}
            label="Action"
            onChange={(event) => handleEditDialogBoxFields(event, "action")}
            InputLabelProps={{ shrink: true }}
          >
            <MenuItem value="">Select</MenuItem>
            <MenuItem value={"H"}>HOLD</MenuItem>
            <MenuItem value={"P"}>Partial Sell</MenuItem>
            <MenuItem value={"S"}>Sell</MenuItem>
          </TextField>
          {/* <FormHelperText>With label + helper text</FormHelperText> */}
          {/* </FormControl> */}
          {dialogBoxfields.action === "P" ? (
            <TextField
              variant="outlined"
              size="small"
              value={dialogBoxfields.quantity}
              // disabled
              label="Quantity"
              InputLabelProps={{ shrink: true }}
              onChange={(event) => handleEditDialogBoxFields(event, "quantity")}
            />
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditModal(false)} variant="outlined">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={(e) => updateFields(e)}
            variant="contained"
            color="primary"
            // disabled={disableeditAmountUpdateBtn}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DetailviewportfolioReview;
